var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeOpened = function SvgEyeOpened(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05625 11.7017C2.98125 11.8941 2.98125 12.1059 3.05625 12.2983C3.78675 13.9854 5.02672 15.428 6.61897 16.443C8.21121 17.4581 10.084 18 12 18C13.916 18 15.7888 17.4581 17.381 16.443C18.9733 15.428 20.2133 13.9854 20.9437 12.2983C21.0187 12.1059 21.0187 11.8941 20.9437 11.7017C20.2133 10.0146 18.9733 8.57202 17.381 7.55695C15.7888 6.54188 13.916 6 12 6C10.084 6 8.21121 6.54188 6.61897 7.55695C5.02672 8.57202 3.78675 10.0146 3.05625 11.7017Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213 9.8787C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.8787C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.8787Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeOpened);
export { ForwardRef as ReactComponent };